import { Color } from "./Color";
import { Font } from "./Font";
import { IFontStyle } from "./IFontStyle";

export class FontStyle {
  constructor(public color: Color = new Color("#000000"), public font: Font = new Font("ＭＳ ゴシック", 9)) { }

  clone(): FontStyle {
    return new FontStyle(
      this.color.clone(),
      this.font.clone(),
    );
  }

  static from(source: IFontStyle): FontStyle {
    if (!source) {
      return null;
    }
    return new FontStyle(Color.from(source.color), Font.from(source.font));
  }

  static to(source: FontStyle): IFontStyle {
    if (!source) {
      return null;
    }
    return {
      color: Color.to(source.color),
      font: Font.to(source.font),
    };
  }
}
